/* eslint-disable @typescript-eslint/no-explicit-any */
import { createApi } from "@reduxjs/toolkit/query/react";
import baseQueryWithReauth from "./BaseQuery";

export const paymentApi = createApi({
  reducerPath: "paymentApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["Payment", "PaymentHistory"],
  endpoints: (builder) => ({
    getPaymentStatistics: builder.query<any, { startDate: string; endDate: string; courier?: string }>({
      query: ({ startDate, endDate, courier }) => {
        let url = `get-payment-statistics?startDate=${startDate}&endDate=${endDate}`;
        if (courier) {
          url += `&courier=${courier}`;
        }
        return url;
      },
      transformResponse: (response: any) => response,
    }),
    getFileUploadHistory: builder.query<any, { page?: string }>({
      query: ({ page }) => {
        let url = `/get-upload-history`;
        if (page) {
          url += `?page=${page}`;
        }
        return url;
      },
      transformResponse: (response: any) => response,
      providesTags: ["PaymentHistory"],
    }),
  }),
});   
export const { useGetPaymentStatisticsQuery, useGetFileUploadHistoryQuery } = paymentApi;

// Helper function to export orders by file ID
export const exportOrdersByFile = async (fileId: string): Promise<{ message: string }> => {
  const token = localStorage.getItem("auth_token");
  try {
    const response = await fetch(`/api/v1/export-orders-by-file/${fileId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error("Failed to export orders");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};